<script>
export default {
    name: "InvestigationsTab",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "lab-request-tab": () => import('./tabs/LabRequest.vue'),
        "imaging-request-tab": () => import('./tabs/ImagingRequest.vue'),
    },
}
</script>
<template>
<div class="w-full max-w-none overflow-auto mt-2 p-tiny" style="height: 55vh;">
    <ul class="flex border-b-2 border-gray-500">
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=0" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 
                font-bold whitespace-no-wrap" 
            :class="active == 0 ? activeClass : inActiveClass">Lab Request</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=1"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 
                font-bold whitespace-no-wrap"
            :class="active == 1 ? activeClass : inActiveClass">Imaging Request</a>
      </li>
    </ul>
    <div class="w-full" v-if="active==0">
        <lab-request-tab></lab-request-tab>
    </div>
    <div class="w-full" v-if="active==1">
        <imaging-request-tab></imaging-request-tab>
    </div>
</div>
</template>
